<template>
  <div class="footer wrap1920">
    <!-- 顶部导航 -->
    <common-header-frame></common-header-frame>

    <router-view v-if="isShowView"/>
    <!-- 右边导航 -->
    <right-navigation></right-navigation>

    <!-- 在线咨询 -->
    <div id="fixedLayer" v-if="$sessionStorageUtil.get('web_type') ==2 && $loginType() != 0">
      <a @click="dialogFormVisible = true" href="javascript:void(0);">在线咨询</a>
      <img class="fixedLayer-icon" src="@/assets/images/html/icon/chat_icon.png">
    </div>

    <el-dialog :visible.sync="dialogFormVisible" @close="closeDialog()" center title="选择销售客服">
      <div class="modal-center">
        <select-sales :activity="select_sale_activity" v-if="dialogFormVisible"></select-sales>
      </div>
    </el-dialog>
    <chat :url="chat_url" v-model="is_show_chat"></chat>
    <!-- 底部导航 -->
    <common-botton-frame></common-botton-frame>
  </div>
</template>
<script>
import SelectSales from '@/pages/common/selectSales.vue'
import Chat from '@/pages/common/chat.vue'
import { CommonHeaderFrame, CommonBottonFrame, RightNavigation } from '@/pages/components'
export default {
  name: 'CommonFrame',
  componentName: "CommonFrame",
  components: {
    CommonHeaderFrame,
    CommonBottonFrame,
    RightNavigation,
    SelectSales,
    Chat
  },
  data () {
    return {
      // element表格test
      dialogFormVisible: false,
      select_sale_activity: 'consult',
      is_show_chat: false,
      chat_url: 'chat/chat.jsp?to=xuxiaohong@oct',
    }
  },
  created () {
    //注册选择销售事件
    this.$on('select.sale', this.selectSale)
    //注册打开选择销售模态框事件
    this.$on('open.select.sale', this.openSelectSale)
    //注册关闭选择销售模态框事件
    this.$on('close.select.sale', this.closeSelectSale)
  },
  computed: {
    isShowView () {
      return this.$store.state.showCommonView
    }
  },
  methods: {
    openSelectSale (from) {
      this.dialogFormVisible = true
      if (from) {
        this.select_sale_activity = from
      }
    },
    selectSale (username) {
      this.chat_url = 'chat/chat.jsp?to=' + username
      let name = this.$router.currentRoute.name
      if (name == 'visaRouteInfo') {
        let route_consult = this.$sessionStorageUtil.get('route_consult')
        if (route_consult) {
          let route_info_url = window.location.protocol + '//' + window.location.host + process.env.FRONT_BASE_URL + 'common/visaRouteInfo?route_id=' + route_consult.route_id
          let consult_route_url = '&route_source=' + route_consult.source +
            '&route_id=' + route_consult.route_id + '&selected_id=' + route_consult.route_plan_id
            + '&route_info_url=' + route_info_url
          this.chat_url += consult_route_url
        }
      }
      this.dialogFormVisible = false
      this.is_show_chat = true
    },
    closeSelectSale () {
      this.dialogFormVisible = false
    },
    closeDialog () {
      console.log('closeDialog')
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/common/commonFrame.vue